'use client'

import { DroppedDocument, useDropzoneContext } from '@repo/ui'
import { cn } from '@repo/ui/lib'

export const DroppedDocuments = ({ className }: { className?: string }) => {
  const { documents, removeDocument, updateDocument } = useDropzoneContext()

  if (documents.length === 0) return null

  return (
    <div className={cn('flex flex-col gap-4 text-left', className)}>
      <table>
        <thead>
          <tr className="border-b border-neutral-200 text-[12px] text-gray-500">
            <th className="w-1/4 max-w-48 py-2 font-normal">Shipment file</th>
            <th className="w-1/3 py-2 font-normal">Document type</th>
            <th className="w-1/4"></th>
          </tr>
        </thead>
        <tbody className="">
          {documents.map((document, index) => (
            <DroppedDocument
              document={document}
              key={document.file.name + index}
              removeDocument={() => removeDocument(document)}
              updateDocument={data => updateDocument(document, data)}
            />
          ))}
        </tbody>
      </table>
    </div>
  )
}
